/**
 * useSelectionResync — extraído de ForecastPage.tsx (P7 split).
 *
 * Re-sincroniza selectedIds contra la misma lista filtrada que renderiza la
 * tabla. Evita duplicar lógica de filtros y evita selecciones invisibles cuando
 * cambian búsqueda, filtros avanzados, vista de compras OFF o filtros futuros.
 */

import { Dispatch, SetStateAction, useEffect } from "react";
import { ProductData } from "./types";

interface UseSelectionResyncOptions {
  filteredAndSortedProducts: ProductData[];
  setSelectedIds: Dispatch<SetStateAction<Set<string>>>;
}

export function useSelectionResync(opts: UseSelectionResyncOptions): void {
  const { filteredAndSortedProducts, setSelectedIds } = opts;

  useEffect(() => {
    setSelectedIds((prev) => {
      const visibleIds = new Set(
        filteredAndSortedProducts.map((p) => p.unifiedProductId),
      );

      const next = new Set<string>();
      prev.forEach((id) => {
        if (visibleIds.has(id)) {
          next.add(id);
        }
      });

      if (next.size !== prev.size) {
        return next;
      }
      return prev;
    });
  }, [filteredAndSortedProducts, setSelectedIds]);
}
